import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import popupItems from "../../../features/Landing/dummy/popupItems";
import promoItems from "../../../features/Landing/dummy/promotionItems";

// Initial state
const initialState = {
  loading: false,
  loaded: null,
  error: false,
  data: null,
  landingItems: [],
  popUpItems: [],
};

// Slice
const promotionSlice = createSlice({
  name: "promotion",
  initialState,
  reducers: {
    getPromotion() {},
    setPromotion(state, action) {
      const { items, destination } = action.payload;
      if (destination === "landing") {
        return {
          ...state,
          landingItems: items,
        };
      } else if (destination === "popUp") {
        return {
          ...state,
          popUpItems: items,
        };
      }
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const {
  getPromotion,
  setPromotion,
  fetchDataSuccess,
  fetchDataFailure,
} = promotionSlice.actions;

export default promotionSlice.reducer;

// saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl, destination, data } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    // let response;
    // if (destination === "landing") {
    //   response = promoItems;
    // } else if (destination === "popUp") {
    //   response = popupItems;
    // }

    const response = yield call(apiService.post, apiUrl, data);
    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      const { code, count, data } = response.data;
      if (code === "0200") {
        yield put(
          setPromotion({
            items: data,
            destination,
          })
        );
      }
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* promotionSaga() {
  yield takeLatest(getPromotion.type, fetchDataSaga);
}
